import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import AuthenticationsServices from "../../Services/AuthenticationService/AuthenticationsServices";
import withRouter from "../../Components/Common/withRouter";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const ResetPassword = () => {
  const { token } = useParams();
  // console.log("Token:", token);
  const location = useLocation();
  // console.log("🚀 ~ ResetPassword ~ location:", location);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      emailAddress: location.state,
      otp: "",
      password: "",
      confirmPassword: "",
      // token: token,
    },
    // Make sure the field names in your validation schema match the ones in your form
    validationSchema: Yup.object({
      otp: Yup.string().required("OTP is required."),
      emailAddress: Yup.string().required("Email Address is required."),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required."),
      password: Yup.string()
        .required("Password is required.")
        .matches(
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
          "Password must contain at least 8 characters, including uppercase, lowercase, and numbers."
        ),
      // token: Yup.string().required("Token is required."), // Add validation for Token
    }),

    onSubmit: (values) => {
      resetPassword(values); // Pass values object without spreading
    },
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const resetPassword = async (pwdData) => {
    try {
      setLoading(true);
      await AuthenticationsServices.resetPassword(pwdData);

      toast.success("Your password has been reset successfully");
      navigate("/login");
      setLoading(false);
    } catch (error) {
      console.log("🚀 ~ resetPassword ~ error:", error);
      toast.error("Sorry,Invalid token!");
      setLoading(false);
    }
  };

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Reset Password</h5>

                    <lord-icon
                      src="https://cdn.lordicon.com/rhvddzym.json"
                      trigger="loop"
                      colors="primary:#0ab39c"
                      className="avatar-xl"
                      style={{ width: "120px", height: "120px" }}
                    ></lord-icon>
                  </div>

                  <div className="p-2">
                    <Form onSubmit={validation.handleSubmit}>
                      <div className="mb-4">
                        <Label className="form-label">Email Address</Label>
                        <Input
                          name="emailAddress"
                          className="form-control"
                          placeholder="Enter your email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailAddress}
                          invalid={
                            validation.touched.emailAddress &&
                            validation.errors.emailAddress
                          }
                        />
                        {validation.touched.emailAddress &&
                          validation.errors.emailAddress && (
                            <FormFeedback type="invalid">
                              {validation.errors.emailAddress}
                            </FormFeedback>
                          )}
                      </div>
                      <div className="mb-4">
                        <Label className="form-label">OTP</Label>
                        <Input
                          name="otp"
                          className="form-control"
                          placeholder="Enter otp"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.otp}
                          invalid={
                            validation.touched.otp && validation.errors.otp
                          }
                        />
                        {validation.touched.otp && validation.errors.otp && (
                          <FormFeedback type="invalid">
                            {validation.errors.otp}
                          </FormFeedback>
                        )}
                      </div>
                      <div className="mb-4">
                        <Label className="form-label"> Password</Label>

                        <Input
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                          }
                        />
                        {validation.touched.password &&
                          validation.errors.password && (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          )}
                      </div>

                      <div className="mb-4">
                        <Label className="form-label">Confirm Password</Label>
                        <Input
                          name="confirmPassword"
                          className="form-control"
                          placeholder="Confirm your password"
                          type="password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.confirmPassword}
                          invalid={
                            validation.touched.confirmPassword &&
                            validation.errors.confirmPassword
                          }
                        />
                        {validation.touched.confirmPassword &&
                          validation.errors.confirmPassword && (
                            <FormFeedback type="invalid">
                              {validation.errors.confirmPassword}
                            </FormFeedback>
                          )}
                      </div>
                      <div className="text-center mt-4">
                        <button
                          className="btn btn-success w-100"
                          type="submit"
                          disabled={loading}
                        >
                          {loading && (
                            <Spinner size="sm" className="me-2">
                              {" "}
                              Loading...{" "}
                            </Spinner>
                          )}
                          Reset Password
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-4 text-center">
                <p className="mb-0 text-black">
                  Wait, I remember my password...{" "}
                  <Link
                    to="/login"
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    {" "}
                    Click here{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ResetPassword.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ResetPassword);
